import { Box, Theme, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { PayBaseModal } from './PayBaseModal';
import { ButtonV2 } from '../ui/PayButton';
import { CheckCircle } from '../ui/CheckCircle';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        zIndex: 99999
    },
    typography: {
        fontWeight: 700
    },
    img: {
        margin: theme.spacing(1, 0, 3, 0)
    },
    successDialogContent: {
        marginBottom: theme.spacing(3)
    }
}));

interface PayItemsAddedModalProps {
    open: boolean;
    onCancel: () => void;
}

export const PayItemsAddedModal: React.FC<PayItemsAddedModalProps> = ({ open, onCancel }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <PayBaseModal open={open} className={classes.root} onClose={onCancel}>
            <Box
                width="100%"
                height="100%"
                display="flex"
                alignItems="center"
                flexDirection="column"
                p={1}
                pt={2}
                pb={1.5}
            >
                <CheckCircle className={classes.img} color={theme.palette.primary.main} />
                <Typography className={classes.typography} gutterBottom align="center" variant="h6">
                    {t('DIALOG_MPO_SUCCESS_TITLE')}
                </Typography>
                <Typography className={classes.successDialogContent} gutterBottom align="center">
                    {t('DIALOG_MPO_SUCCESS_BODY')}
                </Typography>
                <ButtonV2 fullWidth variant="contained" color="primary" onClick={onCancel}>
                    {t('DIALOG_MPO_SUCCESS_OK')}
                </ButtonV2>
            </Box>
        </PayBaseModal>
    );
};
